import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import './styles/Home.css';
import '../../Mobile.css';
import { AuthContext } from '../../context/auth';
import Nav from '../../components/NavBar/components/Nav';
import SideNavBar from '../../components/SideNavBar/sideNavBar';
import fallbackImg from '../../assets/img/fallback.webp';



const Home = () => {
  const { loginUser } = useContext(AuthContext);

  const auth_method = loginUser?.auth_method || 'local'; // Default to 'local' if not sets

  return (
    <>
      <img className='fallbackImgHome' src={fallbackImg} alt="frutas" />
      <div className="fallbackFace" />
      <div className="main-container">
        <nav className="navbar"><Nav /></nav>
        {/* {auth_method !== 'oauth' && (
          <aside className='sidebar'><SideNavBar /></aside>
        )} */}
        <aside className='sidebar'><SideNavBar /></aside>
        <main className="content"><Outlet /></main>
        <footer className="footer" />
      </div>
    </>
  );
};

export default Home;
